import React from "react";

export const IconLightbulb = ({ handleClick = false, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    onClick={() => (handleClick ? handleClick() : null)}
    {...props}
  >
    <path
      d="M8.75002 18.75H11.25M8.12502 16.875H11.875M10 15V9.99996M11.875 15V14.0625C11.875 12.9296 13.1071 11.8582 13.9063 11.0937C15.0328 10.0168 15.625 8.56988 15.625 6.87496C15.625 3.74996 13.1356 1.24996 10 1.24996C9.26076 1.2479 8.52838 1.39199 7.84499 1.67394C7.1616 1.95589 6.54069 2.37015 6.01795 2.89289C5.49521 3.41563 5.08095 4.03654 4.799 4.71993C4.51705 5.40332 4.37296 6.1357 4.37502 6.87496C4.37502 8.50934 4.9926 10.0543 6.09377 11.0937C6.88869 11.8441 8.12502 12.9179 8.12502 14.0625V15H11.875Z"
      stroke="#000000"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M11.4844 9.375C11.4844 9.375 10.6441 10 10 10C9.35586 10 8.51562 9.375 8.51562 9.375"
      stroke="#000000"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconLightbulb;
